import styled from "styled-components";

export const DashboardCardContainer = styled.div`
  width: 300px;
  max-width: 350px;
  height: 215px;
  box-shadow: rgba(0, 0, 0, 0.55) 0px 5px 15px 0px;
  border-radius: 7px;
  margin: 80px 15px;
  display: flex;
  flex-direction: row;
  flex-grow: 1;

  @media only screen and (max-width: 380px) {
    max-width: 150px;
    width: 140px;
    height: 175px;
    margin: 20px 10px;
  }

  @media only screen and (min-width: 379px) and (max-width: 1330px) {
    margin: 30px 5px;
    max-width: 250px;
    height: 250px;
  }

  @media only screen and (min-width: 1950px) {
    margin: 80px 30px;
    max-width: 500px;
    height: 350px;
  }
`;

export const DashboardCardStrip = styled.div`
  height: 100%;
  width: 12px;
  background-color: var(--c1);
`;

export const DashboardCard = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 0 7px 7px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const DashboardCardIconContainer = styled.div`
  width: 100%;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DashboardCardTextContainer = styled.div`
  width: 100%;
  height: 40%;
  text-align: center;
  padding: 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const DashboardCardAmount = styled.h2`
  font-family: AvenirLTProHeavy, sans-serif;
  font-size: 25px;
  color: var(--card-text);
  text-align: center;
  line-height: 0;

  @media only screen and (max-width: 400px) {
    font-size: 15px;
  }
`;

export const DashboardCardHeader = styled.h2`
  font-family: AvenirLTProMedium, sans-serif;
  font-size: 1.2em;
  color: var(--card-text);
  text-align: center;
  line-height: 0;

  @media only screen and (max-width: 400px) {
    font-size: 15px;
  }
`;

export const DashboardCardSubHeader = styled.h2`
  font-family: AvenirLTProMedium, sans-serif;
  font-size: 0.8em;
  color: grey;
  text-align: center;
  line-height: 0;
  background-color: #61dafb;

  @media only screen and (max-width: 400px) {
    font-size: 15px;
  }
`;
